import * as Types from '../../../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
export type ProgramForProgramFlowQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID']['input'];
}>;


export type ProgramForProgramFlowQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, provider: { __typename?: 'Provider', id: string, fullName: string, isPartnered: boolean, showPostLeadRecommendations: boolean, marketplaceConfig: { __typename?: 'ProviderMarketplaceConfig', id: string, programFlowEmailStepHeader: string | null, programFlowBasicInfoStepHeader: string | null, programFlowHeadsUpPhoneDisclaimer: string | null, programFlowHeadsUpEmailDisclaimer: string | null } }, vocation: { __typename?: 'Vocation', id: string, name: string, industry: Types.VocationIndustry } } };

export type ProgramFlowFragmentFragment = { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> };

export type ProgramFlowQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID']['input'];
}>;


export type ProgramFlowQuery = { __typename?: 'Query', programFlow: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } };

export const ProgramFlowFragmentFragmentDoc = gql`
    fragment ProgramFlowFragment on ProgramFlowState {
  id
  hasBlockingStep
  initialStep {
    id
    name
    status
  }
  steps {
    id
    name
    status
  }
}
    ` as unknown as DocumentNode<ProgramFlowFragmentFragment, unknown>;
export const ProgramForProgramFlowDocument = gql`
    query programForProgramFlow($programId: ID!) {
  program(where: {id: $programId}) {
    id
    provider {
      id
      fullName
      isPartnered
      showPostLeadRecommendations
      marketplaceConfig {
        id
        programFlowEmailStepHeader
        programFlowBasicInfoStepHeader
        programFlowHeadsUpPhoneDisclaimer
        programFlowHeadsUpEmailDisclaimer
      }
    }
    vocation {
      id
      name
      industry
    }
  }
}
    ` as unknown as DocumentNode<ProgramForProgramFlowQuery, ProgramForProgramFlowQueryVariables>;
export const ProgramFlowDocument = gql`
    query programFlow($programId: ID!) {
  programFlow(programId: $programId) {
    ...ProgramFlowFragment
  }
}
    ${ProgramFlowFragmentFragmentDoc}` as unknown as DocumentNode<ProgramFlowQuery, ProgramFlowQueryVariables>;